import { cx } from "@suse-o11y/class-variance";

export const BREADCRUMB_ICON_CLASS = cx("size-[18px] brightness-[10]");
